import { render } from "./monthlyCommissionsPaid.vue?vue&type=template&id=5b5bc3f6&ts=true"
import script from "./monthlyCommissionsPaid.vue?vue&type=script&lang=ts"
export * from "./monthlyCommissionsPaid.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\projects\\Auraclub\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__